import React from "react";

import TimeToDeliveryCellContent from "../components/TimeToDeliveryCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function timeToDelivery({ width, onResize, tableType }: Column.Options) {
	return base(
		ColumnId.TimeToDelivery,
		(item) => <TimeToDeliveryCellContent item={item} />,
		{
			width,
			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
		tableType,
	);
}

export default timeToDelivery;
